import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { AkaTravelProduct } from "Store/interfaces/products/checkout/riskProducts/AkaTravelProduct";
import React from "react";
import { ProductDetail } from "../../interface";

export const akaTravelDetailsList = (
  product: AkaTravelProduct,
  types: any,
  lang: string,
  urls: Record<string, string>,
): ProductDetail[] => {
  const { applicableTermsTravel } = urls;

  return [
    {
      name: "coverage",
      value: types.coverageGroup[product.coverageGroup][lang],
    },
    {
      name: "travelTime",
      value: types.travelTime[product.coverageGroup][lang],
    },
    {
      name: "deductible",
      value: (
        <a href={applicableTermsTravel} target="_blank" rel="noreferrer">
          <DeductibleValue
            value={product.priceSpecifications.deductible.code ?? "??"}
          />
        </a>
      ),
    },
  ];
};
